module.exports = __webpack_public_path__ + "media/images/landing/cuate-9d548496335b72b1d8baf119dc96c024.svg";